import { apiSlice } from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllAssignment: builder.query({
            query: () => ({
                url: "/assignments",
                method: "GET",
            }),   
        }),
        postAssignments: builder.mutation({
            query: (data) => ({
                url: "/assignments",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    if(result?.data?.id){

               
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllAssignment", undefined,
                                (draft) => {
                               
                                  draft.push(arg)
                                }
                                ))
                                
                            }


                    

                   
                } catch (err) {
                    // do nothing
                }
            },
          
          
        }),
        getAllAssignmentMark: builder.query({
            query: () => ({
                url: "/assignmentMark",
                method: "GET",
            }),   
        }),
       
        getSAssignment: builder.query({
            query: (id) => ({
                url: `/assignments/${id}`,
                method: "GET",
            }),   
        }),
        updateSAssignment: builder.mutation({
            query: ({id,data}) => ({
                url: `/assignments/${id}`,
                method: "PATCH",
                body: data,

            }),   
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    
                    
                    
                    if (result?.data?.id) {
                        

                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllAssignment", undefined,
                                (draft) => {
                                  
                                    const draftQuiz = draft.find(
                                        (c) => c.id == arg.id
                                    );
                                  
    
                                
                                    draftQuiz.title = arg.data.title;
                                    draftQuiz.video_id = arg.data.video_id;
                                    draftQuiz.totalMark = arg.data.totalMark;

                                }
                            ))
                    }




                } catch (err) {
                    // do nothing
                }
            },

        }),
        deleteSAssignment: builder.mutation({
            query: (id) => ({
                url: `/assignments/${id}`,
                method: "DELETE",
              

            }),   

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {


                // optimistic cache update start
              
                // optimistic cache update end
                try {
                  const result = await queryFulfilled;
             
                  if(result?.meta?.response?.status==200){
                    dispatch(
                        apiSlice.util.updateQueryData(
                          "getAllAssignment", undefined,
                          (draft) => {
                         
                            draft.splice(draft.findIndex(t=>t.id==arg),1);
                        
              
                          }
                        )
                      );
                  }
        
                } catch (err) {
                 
                }
              },
          

        }),
        getAssignmentByVideo: builder.query({
            query: (id) => ({
                url: `/assignments?video_id=${id}`,
                method: "GET",
              

            }),   
        }),
        getQuiz: builder.query({
            query: ({videoId}) => ({
                url: `/quizzes?video_id=${videoId}`,
                method: "GET",
            }),   
        }),
    }),
});

export const { useGetAllAssignmentQuery,useGetAllAssignmentMarkQuery, usePostAssignmentsMutation ,useGetSAssignmentQuery ,useUpdateSAssignmentMutation, useDeleteSAssignmentMutation ,useGetAssignmentByVideoQuery}  = assignmentApi;